module.exports = __webpack_public_path__ + "static/img/logo_my.9aa6b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newIndex/logo_my.jpg
// module id = Uisj
// module chunks = 68